import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Group} from '@signature-it/ngx-catalogue/models';
import {CookieService} from "ngx-cookie-service";

@Injectable({
    providedIn: 'root'
})
export class SessionVarietyService {
    constructor (
        protected http: HttpClient,
        protected restUrlsConfig: RestUrlsConfig,
        private cookie: CookieService,
    ) {}

    getCookieFields(){
        let fields = {};
        if (this.cookie.get('varietySessionValue')) {
            let cookie = this.cookie.get('varietySessionValue').replace(/fq\=/gi, "").split('&');
            cookie.forEach(function (value) {
                let fieldArr = value.split(":");
                fields[fieldArr[0]] = fieldArr[1];
            });
        }
        return fields;
    }

    getCookieFieldsFromOneField(fieldName){
        let fields = [];
        if (this.cookie.get('varietySessionValue')) {
            let re = new RegExp('fq=[A-Za-z\_]*:', 'gi');
            fields = this.cookie.get('varietySessionValue').slice(0, -1).replace(/<>/g, " ").replace(re, "").split('@@');
        }
        return fields;
    }

    setCookieFields(data){
        let fqs = [];
        for(let field in data){
            fqs.push(`fq=${field}:${data[field]}`);
        }
        let fq = fqs.join("&");
        this.cookie.set('varietySessionValue', fq, null, '/', this.restUrlsConfig.ssoDomain, false, 'Lax');
    }

    setCookieFieldsToOneField(data, fieldName){
        let fields = [];
        for(let field in data){
            fields.push(data[field]);
        }
        this.cookie.set('varietySessionValue', `fq=${fieldName}:${fields.join("@@").replace(/ /g, "<>")}*`, null, '/', this.restUrlsConfig.ssoDomain, false, 'Lax');
    }

    reset() {
        this.cookie.set('varietySessionValue', '', null, '/', this.restUrlsConfig.ssoDomain, false, 'Lax');
    }

}
